import { useParams, Link } from 'react-router-dom';
import { MODELS_3D } from '@/data/content';
import Breadcrumb from '@/components/ui/Breadcrumb';

export default function ModelDetailPage() {
  const { modelId } = useParams<{ modelId: string }>();
  const model = MODELS_3D.find((m) => m.id === modelId);

  if (!model) return <div className="max-w-4xl mx-auto px-6 pt-8"><p className="text-text-disabled">模型未找到</p></div>;

  return (
    <div className="max-w-4xl mx-auto px-6 pt-8 pb-16">
      <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '模型库', href: '/models' }, { label: model.name }]} />

      <div className="flex flex-col md:flex-row items-start gap-8 mb-12">
        <div className="w-full md:w-96 bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt flex items-center justify-center shrink-0 overflow-hidden relative group">
          <img src={model.image} alt={model.name} className="w-full object-contain" />
          <div className="absolute top-3 right-3">
            <span className="text-[10px] bg-panel-dark/80 text-text-secondary px-2 py-1 rounded-tag">拖拽可旋转</span>
          </div>
        </div>
        <div className="flex-1">
          <h1 className="text-xl font-extrabold text-text-primary mb-2">{model.name}</h1>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-5 h-5 rounded-full bg-border-dark" />
            <span className="text-sm text-text-secondary">{model.creator}</span>
            <span className={`text-[10px] px-1.5 py-0.5 rounded-tag ${model.commission === 25 ? 'bg-arena-gold/15 text-arena-gold' : 'bg-border-dark text-arena-gold'}`}>{model.commission}% 佣金</span>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-5 text-sm">
            {[['下载次数', model.downloads.toLocaleString()], ['佣金比例', `${model.commission}%`], ['文件格式', 'STL / STEP'], ['许可协议', 'CC BY-NC-SA']].map(([k, v]) => (
              <div key={k} className="flex justify-between py-1.5 border-b border-border-dark/50"><span className="text-text-disabled">{k}</span><span className="text-text-secondary">{v}</span></div>
            ))}
          </div>
          <div className="flex gap-3">
            <button className="px-8 h-10 rounded-btn bg-arena-blue text-white text-sm font-bold hover:brightness-110 transition-all">下载 STL</button>
            <button className="px-5 h-10 rounded-btn border border-arena-blue text-arena-blue text-sm font-bold hover:bg-arena-blue/10 transition-all">收藏</button>
          </div>
        </div>
      </div>

      <div className="border-t border-border-dark pt-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-extrabold text-text-primary">相关模型</h2>
          <Link to="/models" className="text-xs text-arena-blue hover:underline">返回模型库</Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {MODELS_3D.filter((m) => m.id !== model.id).map((m) => (
            <Link key={m.id} to={`/models/${m.id}`} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3 hover:border-arena-blue/40 transition-all group">
              <img src={m.image} alt={m.name} className="h-24 w-full object-cover rounded mb-2" />
              <p className="text-xs text-text-primary">{m.name}</p>
              <p className="text-[11px] text-text-disabled">{m.creator}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
